export const isTouchDevice = (): boolean => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const isTouchOnlyDevice = (): boolean => {
  return matchMedia('(hover: none)').matches;
};
